import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase.config';

export async function signInFromPublicSSO() {
  try {
    const url = process.env.REACT_APP_SSO_EXCHANGE_URL || 'http://localhost:3003/api/sso/exchange';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include'
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || 'SSO exchange failed');
    if (data?.customToken) {
      await signInWithCustomToken(auth || getAuth(), data.customToken);
      return { success: true, uid: data.uid };
    }
    return { success: false, error: 'No token' };
  } catch (e) {
    return { success: false, error: e?.message || 'Failed' };
  }
}


